import React from 'react';
import { ToggleRow, T } from './ui';
import { GENDER_OPTIONS, genderLabel } from '../../../utils/portalPageModel';

/**
 * GENDER — pills, tap again to clear, plus "Hide gender on my page". Hidden still keeps the pick
 * (so turning the toggle back off restores it); `buildPortalPayload` sends `gender: null` while it
 * is on. The pills fade to .4 while hidden so the state reads at a glance.
 *
 * `label` lets onboarding print "GENDER · OPTIONAL" over the same control.
 */
export default function GenderField({ value, onChange, hidden, onToggleHidden, label = 'GENDER', optional = false }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <span style={T.label}>{label}{optional && <span style={{ color: '#6B6B6B' }}> · OPTIONAL</span>}</span>
      <span style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {GENDER_OPTIONS.map((g) => {
          const sel = (value || '').toUpperCase() === g;
          return (
            <button
              key={g}
              type="button"
              aria-pressed={sel}
              onClick={() => onChange(sel ? '' : g)}
              style={{ height: 38, padding: '0 16px', border: 'none', borderRadius: 999, background: sel ? '#fff' : '#161616', color: sel ? '#000' : '#fff', boxShadow: sel ? 'none' : 'inset 0 0 0 1px #2A2A2A', opacity: hidden ? 0.4 : 1, fontFamily: 'inherit', fontSize: 10, fontWeight: 700, letterSpacing: '.14em', textTransform: 'uppercase', cursor: 'pointer', transition: 'background-color .2s, color .2s, opacity .2s' }}
            >
              {genderLabel(g)}
            </button>
          );
        })}
      </span>
      <ToggleRow on={hidden} onToggle={onToggleHidden} label="Hide gender on my page" />
    </div>
  );
}
